import script from "./EmailComposeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailComposeModal.vue?vue&type=script&setup=true&lang=ts"

import "./EmailComposeModal.vue?vue&type=style&index=0&id=d6f1c88a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6f1c88a"]])

export default __exports__